import { themeGet } from 'styled-system'
import styled from 'styled-components'

interface ContainerProps {
  siteChangeChecked: boolean
}

export const Container = styled.div<ContainerProps>`
  padding: 0.1875rem 1rem 0.4375rem;
  margin-bottom: 1.5rem;
  border-radius: 0.3125rem;
  border: 0.125rem solid
    ${({ siteChangeChecked }) =>
      siteChangeChecked
        ? themeGet('colors.successGreen')
        : themeGet('colors.errorLightRed')};
`
